import { render, staticRenderFns } from "./DashboardDespesas.vue?vue&type=template&id=2e110d9c&scoped=true&"
import script from "./DashboardDespesas.vue?vue&type=script&lang=js&"
export * from "./DashboardDespesas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDespesas.vue?vue&type=style&index=0&id=2e110d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e110d9c",
  null
  
)

export default component.exports